/**
 * Show Password on Login Form Page and Navbar
 */
window.mostrarContrasena = function (btn) {
    $(btn).blur();
    if ($(btn).closest('.input-group').find('input').attr('type') === 'password') {
        $(btn).addClass('active');
        $(btn).find('i').removeClass('fa-eye').addClass('ri-eye-off-line');
        $(btn).closest('.input-group').find('input').attr('type', 'text');
    } else {
        $(btn).removeClass('active');
        $(btn).find('i').removeClass('ri-eye-off-line').addClass('ri-eye-line');
        $(btn).closest('.input-group').find('input').attr('type', 'password');
    }
};

/**
 * Delay
 */
window.throttle = function (f, delay) {
    let timer = null;
    return function () {
        let context = this,
            args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
            f.apply(context, args);
        }, delay || 750);
    };
};

/**
 * Scroll To Top
 */
window.scrollToTop = function () {
    $("html, body").animate({scrollTop: 0}, "fast");
}

/**
 * Scroll To Bottom
 */
window.scrollToBottom = function () {
    let footerOffset = $('.site-footer').offset().top;
    let windowHeight = $(window).height();
    let scrollPosition = footerOffset - windowHeight;
    $('html, body').animate({scrollTop: scrollPosition}, 'fast');
}

/**
 * Scroll to selector element on DOM
 *
 * @param   {string}  selector    The selector where scroll to
 */
window.slideToElement = function (selector = null) {
    // Get the element
    const element = document.querySelector(selector);
    // Get the focus out
    $(this).blur();
    // Check if the element is height is not defined
    if (!element || !element.offsetTop) {
        // Cut the execution
        return;
    }
    // Go to the top
    $("html, body").animate({scrollTop: element.offsetTop}, "fast");
    return false;
};

/**
 * CHECKS
 */

/**
 * Determina si el objeto recibido está vacío
 *
 * @param      {Object}   obj     The object
 * @return     {boolean}  True if empty, False otherwise.
 */
window.isEmpty = function (obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return true;
};

/**
 * Calcula el PVP (con IVA) de un artículo.
 *
 * - Fórmula general:
 *   (Precio de Distribución * (1 + (Beneficio / 100))) * (1 + (IVA / 100))
 *   con descuento opcional aplicado primero.
 *
 * - Fórmula texto curricular:
 *   (Coste s/IVA para el librero / (1 - (Beneficio / 100))) * (1 + (IVA / 100))
 *   con descuento opcional aplicado primero.
 *
 * @param  {number} precio        Base (general: precio distribución; curricular: coste s/IVA librero)
 * @param  {number} iva           IVA (%)
 * @param  {number} descuento     Descuento (%) (default: 0)
 * @param  {number} beneficio     Beneficio/Margen (%) (default: 0)
 * @param  {string} tipoArticulo  Tipo de artículo ('l' (libros), 'p' (papelería), 'j' (juegos), 't' (libros de texto curriculares) o 'a' (audiovisuales)) (por defecto: '')
 * @return {number}
 */
window.calcularPVP = function (precio, iva, descuento = 0, beneficio = 0, tipoArticulo = '') {
    precio = precio - (precio * descuento / 100);

    if (tipoArticulo === 't') {
        const margen = beneficio / 100;
        if (margen >= 1) {
            return 0;
        }

        precio = precio / (1 - margen);
    } else {
        precio = precio + (precio * beneficio / 100);
    }

    return precio + (precio * iva / 100);
}

/**
 * Copia un texto al portapapeles
 *
 * @param {string} text
 * @returns {Promise<void>}
 */
window.copyToClipboard = async function (text) {
    if (text && typeof text === "string") {
        await navigator.clipboard.writeText(text);
    }
};

/**
 * Obtiene el idioma de la agrupación del usuario autenticado
 *
 * @returns {string} Idioma de la agrupación
 */
window.getLocaleFromGroups = function () {
    // Si el usuario no tiene agrupaciones, devolvemos el idioma por defecto, que es el español
    if (!Array.isArray(agrupaciones) || agrupaciones.length === 0) {
        return 'es';
    }

    let agrupacionesUsuario = agrupaciones.slice();

    // Si el usuario tiene más de una agrupación y una de ellas es 'xarxa', la eliminamos
    if (agrupacionesUsuario.length > 1 && agrupacionesUsuario.includes('xarxa')) {
        agrupacionesUsuario = agrupacionesUsuario.filter(item => item !== 'xarxa');
    }

    const agrupacion = agrupacionesUsuario[0];

    // Agrupaciones correspondientes al euskera
    if ([
        'elkar',
        'baiona'
    ].includes(agrupacion)) {
        return 'eu';
    }

    // Agrupaciones correspondientes al catalán
    if ([
        'mcl',
        'xarxa',
        'distriaula'
    ].includes(agrupacion)) {
        return 'ca';
    }

    // El resto de las agrupaciones se corresponden al castellano
    return 'es';
}

/**
 *  @param avisos
 *  @param {String} [idAlerta=''] - (Opcional) ID del contenedor de alertas en el DOM. Si se proporciona, el mensaje se mostrará allí
 *                                 Si no se indica, se usará un notify para mostrar el mensaje
 */
window.showAvisosArticulos = function (avisos, idAlerta = '') {
    const tiposAvisos = [
        transAlertaArticulosNoPedibles,
        transArticulosConComunidadDiferente,
    ];

    let contenido = '';

    avisos.forEach((aviso, index) => {
        const titulo = tiposAvisos[aviso.tipo] || '';
        contenido += `<strong>${titulo}</strong><br>`;

        if (Array.isArray(aviso.articulos) && aviso.articulos.length > 0) {
            contenido += '<ul style="margin: 0">';
            aviso.articulos.forEach(articulo => {
                contenido += `<li>${articulo.ean}</li>`;
            });
            contenido += '</ul>';
        }

        if (index < avisos.length - 1) {
            contenido += '<br>';
        }
    });

    if (idAlerta.length > 0) {
        const $alerta = $(`#${idAlerta}Warning`);
        $alerta.find('span').html(contenido);
        $alerta.show();
    } else {
        pNotifyWarning(contenido);
    }
}

/**
 * Elimina las etiquetas HTML de un texto, devolviendo solo el texto plano
 *
 * @param html
 * @returns {*|jQuery}
 */
window.stripHtml = function (html) {
    return $('<div>').html(html || '').text();
}
